"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
const _excluded = ["children", "className", "id", "onComplete", "open"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const UX_REVEAL_CLASSNAME = 'ux-reveal';

/**
 * Create a <Reveal/> component
 *
 * @param {Object} props - Configuration object
* @param {Node} props.children - Content to be revealed
 * @param {String} [props.className] - Classname for positioning
 * @param {String} props.id - Unique identifier for accessibility
 * @param {Function} [props.onComplete] - Fires once the disclosure has completed opening/closing
 * @param {Boolean} [props.open] - Determines if disclosure is open/closed
 * @returns {Component} - Reveal component
 */

function Reveal(_ref) {
  let {
      children,
      className,
      id,
      onComplete = Function.prototype,
      open
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  delete rest.style;

  /**
   * While the transition is most apparent on the root element, we assign this callback to the content container.
   * This is a workaround due to a discrepancy within Cypress tests.
   * In headless-mode, the grid-template-rows transition on the root element does not fire.
   * The only transition that fires in both headless and browser tests is the visibility on the inner content.
   */
  const onTransitionEnd = (0, _react.useCallback)(function _onTransitionEnd(event) {
    event.propertyName === 'visibility' && onComplete(open, {
      event
    });
  }, [open, onComplete]);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    id: id,
    "data-version": "2400",
    className: (0, _classnames.default)(`${UX_REVEAL_CLASSNAME}-shell`, className),
    "data-open": open
  }, rest), /*#__PURE__*/_react.default.createElement("div", {
    className: `${UX_REVEAL_CLASSNAME}-content`,
    onTransitionEnd: onTransitionEnd
  }, children));
}
Reveal.propTypes = {
  /** Content to be revealed */
  children: _propTypes.default.node.isRequired,
  /** Classname for positioning */
  className: _propTypes.default.string,
  /** Unique identifier for accessibility */
  id: _propTypes.default.string.isRequired,
  /** Fires once the disclosure has completed opening/closing */
  onComplete: _propTypes.default.func,
  /** Determines if disclosure is open/closed */
  open: _propTypes.default.bool
};
Reveal.displayName = 'Reveal';
var _default = exports.default = Reveal;